import { render, staticRenderFns } from "./WEBTILECHOOSER.vue?vue&type=template&id=2bae5a16"
import script from "./WEBTILECHOOSER.vue?vue&type=script&lang=js"
export * from "./WEBTILECHOOSER.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports